import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query CountHouseEntrancesQuery($filters: [Filter], $companyId: ID!) {
    Me {
      id
      Company(id: $companyId) {
        data: countHouseEntrances(options: { filters: $filters })
      }
    }
  }
`
